import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import {
  deletePromotionAPI,
  getAllPromotionsAPI,
} from "../../services/Promotions/promotion";
import { setListPromotions } from "../../redux/slice/promotions";
import { useDispatch } from "react-redux";

const ModalDeletePromotion = ({
  open,
  setOpen,
  promotionData,
  type,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const handleDelete = async () => {
    try {
      setLoading(true);
      await deletePromotionAPI(promotionData?._id);
      const responsePromotions = await getAllPromotionsAPI();
      dispatch(setListPromotions({ listPromotions: responsePromotions ?? [] }));
      toast.success(
        `Promoción ${promotionData?.nameDiscount ?? ""} eliminada correctamente.`
      );
      setLoading(false);
      setOpen(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      setOpen(false);
      toast.error(
        `Error al eliminar la promoción. Por favor, inténtalo de nuevo. \n ${message}`
      );
    }
  };
  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle variant="h6" fontWeight="bold" textAlign={"center"}>
        ¿Deseas eliminar la promoción {promotionData?.nameDiscount ?? ""}?
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", justifyContent: "center", marginTop: 5 }}>
          {promotionData?.urlImg && (
            <img
              src={promotionData?.urlImg ?? ""}
              alt="QR de descuento."
              width={200}
            />
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: "flex", gap: 3 }}>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          onClick={() => {
            setOpen(false);
          }}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          variant="outlined"
          color="white"
          onClick={handleDelete}
          startIcon={<DeleteForeverIcon />}
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ModalDeletePromotion;
